import { Entity } from './entity.base';

export interface Mapper<DomainEntity extends Entity<any>, Response = any> {
  toDomain(record: any): DomainEntity;
  toResponse(entity: DomainEntity): Response;
}
